import React from 'react';
import Modal from 'react-bootstrap-modal';
import SelectInput from '../controls/selectInput.jsx';

export default class StatusSelectionModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            isOpen: false,
            title: "",
            statuses: [],
			selection: null,
            promiseResolve: null,
            promiseReject: null
        };
    }

    open(title, statuses) {
        let promise = new Promise((resolve, reject) => {
            this.setState({
                isOpen: true,
                title: title,
                statuses: statuses,
				selection: null,
                promiseResolve: resolve,
                promiseReject: reject
            });
        });
        return promise;
    }

    close(result) {
        if (result) {
            this.state.promiseResolve(this.state.selection);
        } else {
            this.state.promiseReject();
        }
        this.setState({
            isOpen: false,
            title: "",
            statuses: [],
			selection: null,
            promiseResolve: null,
            promiseReject: null
        });
    }

    render() {
        return (
            <Modal show={this.state.isOpen} 
				onHide={() => this.close(false)} 
				aria-labelledby="ModalHeader" 
				backdrop="static"
			>
                <Modal.Header closeButton>
                    <Modal.Title id='ModalHeader'>
						{this.state.title}
					</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label htmlFor="modalSelectStatus">Выберите новый статус</label>
                        <SelectInput id="modalSelectStatus"
                            options={this.state.statuses}
                            value={this.state.selection}
                            onChange={e => this.setState({ selection: e ? e.value : null })}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-primary' 
						onClick={() => this.close(true)}
						disabled={this.state.selection == null}
					>
						Применить
					</button>
                    <Modal.Dismiss className='btn btn-default'>
						Отмена
					</Modal.Dismiss>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./App/modals/statusSelectionModal.jsx